import React, {
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react';
import _ from 'lodash';

import { TranslatorContext } from '@jutro/locale';
import { SgDateUtil, useSgTrackPageName } from 'saga-modules';
import { CepConstants } from 'saga-cep-specific-components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { Button } from '@jutro/components';
import { events } from 'gw-platform-events-js';
import CommonConstants from 'sg-common-constants';
import SgDriverAdditionalQuestions from '../sg-driver-additional-questions/SgDriverAdditionalQuestions';
import metadata from './SgRemoveDriver.metadata.json5';
import messages from './SgRemoveDriver.messages';

function SgRemoveDriver(props) {
    const {
        id,
        modelVM,
        updateData,
        handleCancel,
        handleGoBack,
        onContinue: onParentContinue
    } = props;

    const {
        isComponentValid,
        onValidate
    } = useValidation(id);
    const translator = useContext(TranslatorContext);

    const [showErrors, setShowErrors] = useState(false);
    const [driverIdRemove, setDriverIdRemove] = useState(-1);

    useSgTrackPageName(CepConstants.PAGE_NAMES.DRIVER_CHANGES_REMOVE);

    const driversSelectContent = useMemo(() => {
        const drivers = _.get(modelVM, 'lobData.privateMotor.coverables.spmDrivers.value');
        if (drivers && drivers.length) {
            const sortedDrivers = _.sortBy(drivers, (driver) => {
                return parseInt(driver.publicID, 10);
            });
            return sortedDrivers.map((driver) => {
                return (
                    <div key={driver.publicID} className="sgRemoveDriverDetailsContainer">
                        <div>{driver.person.displayName}</div>
                        <div>{SgDateUtil.toStringShort(driver.person.dateOfBirth)}</div>
                        <Button
                            type="button"
                            disabled={driver.isPolicyHolder}
                            className="sgButton sgSecondaryButton"
                            onClick={() => setDriverIdRemove(driver.publicID)}
                        >
                            {translator(messages.Select)}
                        </Button>
                    </div>
                );
            });
        }
        return '';
    }, [modelVM, driverIdRemove]);

    const onContinue = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true);
            events.emit(CommonConstants.SHOW_VALIDATION_ERROR_EVENT);
            return; // Do not continue
        }
        const modelCopy = _.clone(modelVM);
        _.remove(modelCopy.lobData.privateMotor.coverables.spmDrivers.value, (el) => el.publicID === driverIdRemove);
        updateData(modelVM);
        onParentContinue();
    }, [driverIdRemove, isComponentValid, modelVM, onParentContinue, updateData]);

    const overrideProps = {
        cepEndorsementSelectDriverToRemove: {
            content: driversSelectContent
        },
        additionalQuestionsHeader: {
            visible: driverIdRemove !== -1
        },
        removeDriverAdditionalQuestions: {
            visible: driverIdRemove !== -1,
            driverIdRemove,
            modelVM,
            onValidate,
            updateData,
            showErrors,
        },
        continueButton: {
            visible: driverIdRemove !== -1,
            onClick: onContinue
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            handleCancel,
            handleGoBack
        },
        resolveComponentMap: {
            SgDriverAdditionalQuestions: SgDriverAdditionalQuestions
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            onModelChange={updateData}
            onValidationChange={onValidate}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SgRemoveDriver;
